import { makeInflect } from "../../../../core/utils/makeInflect.js";

// Genitive after "z/ze": z 1 druhu, ze 2 druhů, ze 17 druhů
export const inflectKind = makeInflect("druhu", "druhů", "druhů");

// The preposition "z" is vocalized by the pronunciation of the numeral: ze 2 (dvou), ze 17 (sedmnácti),
// but z 5 (pěti), z 8 (osmi). The first spoken word of a number below 100 is decided by the units digit
// for 0–19 (dvanáct, patnáct, …) and by the tens digit for 20–99 (dvacet, padesát, …).
export function zPrepositionForCount(count: number): string {
	const leadingNumeralDigit = count < 20 ? count % 10 : Math.floor(count / 10) % 10;
	return [2, 3, 4, 6, 7].includes(leadingNumeralDigit) ? "ze" : "z";
}
